export default __webpack_public_path__ + "static/icon-13-1-516591ab758ccd93a187e73d83d0519a.png";